import { PAGE_ACTIONS } from './page';
import { EVENTS_ACTIONS } from './events';
import { MEDIA_ACTIONS } from './media';
import { LEADERBOARD_ACTIONS } from './leaderboard';
import { TRANSLATIONS_ACTIONS } from './translations';
import { NAVIGATION_ACTIONS } from './navigation';
import { CULTURE_ACTIONS } from './cultures';

export const ACTIONS = {
  PAGE: PAGE_ACTIONS,
  EVENTS: EVENTS_ACTIONS,
  MEDIA: MEDIA_ACTIONS,
  LEADERBOARD: LEADERBOARD_ACTIONS,
  TRANSLATIONS: TRANSLATIONS_ACTIONS,
  NAVIGATION: NAVIGATION_ACTIONS,
  CULTURES: CULTURE_ACTIONS,
};
